import { render, staticRenderFns } from "./loading-button.vue?vue&type=template&id=ac9ca506&scoped=true&"
import script from "./loading-button.vue?vue&type=script&lang=ts&"
export * from "./loading-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9ca506",
  null
  
)

export default component.exports